import { UploadDropZone } from '../upload/UploadDropZone';

/**
 * Dedicated upload route. Mounts the drag-drop zone with the
 * auto-open flag so the folder chooser opens immediately after the
 * navigation that landed the user here. Drag-drop still works as a
 * fallback if they cancel the picker.
 */
export function UploadPage() {
  return (
    <div className="mx-auto max-w-3xl">
      <div className="font-mono text-xs uppercase tracking-widest text-[color:var(--color-text-muted)]">
        Upload
      </div>
      <h1 className="mt-1 text-2xl font-semibold">Choose your delivery folder</h1>
      <p className="mt-2 text-sm text-[color:var(--color-text-secondary)]">
        Pick the folder containing your <code className="font-mono">metadata.csv</code> and
        per-title subfolders. We'll generate a unique batch ID and stream every file
        directly to storage. You can drag a folder onto the zone too.
      </p>
      <UploadDropZone autoOpenChooser />
    </div>
  );
}
